import React from 'react';
import { useEntity, ENTITY_CONFIG } from '../../context/EntityContext';
import { Building2, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

const EntityToggle = () => {
  const { currentEntity, switchEntity } = useEntity();
  const current = ENTITY_CONFIG[currentEntity];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="w-full flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 bg-gray-50 hover:bg-gray-100 transition-all"
          data-testid="entity-toggle"
        >
          <div className={`w-7 h-7 rounded-md ${current.color} flex items-center justify-center text-white text-xs font-bold shrink-0`}>
            {current.shortLabel}
          </div>
          <div className="flex-1 text-left min-w-0">
            <p className="text-xs font-semibold text-gray-800 truncate">{current.label}</p>
            <p className="text-[10px] text-gray-500">Active Entity</p>
          </div>
          <ChevronDown className="h-3.5 w-3.5 text-gray-400 shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        {Object.entries(ENTITY_CONFIG).map(([key, cfg]) => (
          <DropdownMenuItem
            key={key}
            onClick={() => switchEntity(key)}
            className={`flex items-center gap-2 cursor-pointer ${currentEntity === key ? 'bg-gray-100' : ''}`}
            data-testid={`entity-option-${key}`}
          >
            <div className={`w-6 h-6 rounded ${cfg.color} flex items-center justify-center text-white text-xs font-bold`}>
              {cfg.shortLabel}
            </div>
            <span className="text-sm">{cfg.label}</span>
            {currentEntity === key && <span className="ml-auto text-xs text-emerald-600 font-medium">Active</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default EntityToggle;
